import React, { useContext } from 'react'
import StoreContext from '../../../providers/storesContext'
import CaseDetailPrice from '../../../components/CaseDetailPrice/CaseDetailPrice'
import InvoiceSummaryLineItem from './InvoiceSummaryLineItem'

const InvoiceSummary = () => {
  const { caseDetailStore } = useContext(StoreContext)

  const { immobilizationCase, isAssistedRelease } = caseDetailStore

  return (
    <div className="mb-4">
      <div className="font-bold my-2">Invoice:</div>
      <div>
        {immobilizationCase?.bill?.lineItems.map((lineItem, index) => (
          <InvoiceSummaryLineItem key={index} item={lineItem} />
        ))}
        <div className="flex justify-between my-2">
          <div>-</div>
          <div>-</div>
        </div>
        <CaseDetailPrice total={immobilizationCase?.bill?.total} />
      </div>
    </div>
  )
}

export default InvoiceSummary
